<template>
    <div>
        <ips-by-type-component
            :type="1"
            :ips="ips"
            :ip-groups="ipGroups"
        />
        <groups-component
            :ip-groups="ipGroups"
            :ips="ips"
        />
        <ips-by-type-component
            :type="2"
            :ips="ips"
            :ip-groups="ipGroups"
        />
        <modal-form
            v-if="stateModal"
            :modal="modal"
            @close="closeModal"
        />
    </div>
</template>

<script>
import GroupsComponent from './templates/group/GroupsComponent';
import IpsByTypeComponent from './templates/ip/IpsByTypeComponent';
import EventBus from '../../event-bus';
import routes from './data/routes';

export default {
    components: {
        IpsByTypeComponent,
        GroupsComponent,
    },
    data() {
        return {
            ipGroups: null,
            ips: null,
            routes,
            stateModal: false,
            modal: {},
        };
    },
    created() {
        // Show modal
        EventBus.$on('showModalForm', (data) => {
            this.modal = data;
            this.showModal();
        });

        // Delete IP
        EventBus.$on('deleteIpModalUpdate', (data) => {
            this.$delete(this.ips, this.getCurrentIpIndex(data.id));
            this.closeModal();
        });

        // Create IP
        EventBus.$on('addIpModalUpdate', (data) => {
            this.ips.push(data);
            this.closeModal();
        });

        // Delete group
        EventBus.$on('deleteGroupModalUpdate', (data) => {
            this.$delete(this.ipGroups, this.getCurrentGroupIndex(data.id));
            this.closeModal();
        });

        // Update IP
        EventBus.$on('updateIpDataUpdate', (data) => {
            this.$set(this.ips, this.getCurrentIpIndex(data.id), data);
        });
    },
    mounted() {
        this.getGroups();
        this.getIps();
    },
    methods: {
        getGroups() {
            axios
                .get(routes.group.get)
                .then((response) => {
                    this.ipGroups = response.data.items;
                })
                .catch(() => {});
        },
        getIps() {
            axios
                .get(routes.ip.get)
                .then((response) => {
                    this.ips = response.data.items;
                })
                .catch(() => {});
        },
        getCurrentIpIndex(id) {
            return this.ips.findIndex((ip) => {
                return ip.id === id;
            });
        },
        getCurrentGroupIndex(id) {
            return this.ipGroups.findIndex((group) => {
                return group.id === id;
            });
        },
        showModal() {
            this.stateModal = true;
        },
        closeModal() {
            this.stateModal = false;
        },
    },
};
</script>
